export enum retrievalMethodType {
    Provider_Email_Upload = 7,
    BulkUpload = 11,
}
